import React, { isValidElement } from 'react';
import moment from 'moment';

import { CondensedSmall } from '../../content/CondensedSmall/CondensedSmall';
import { Gutter } from '../../layout/Gutter/Gutter';

export type CalendarTimeSlotProps = {
  value: Date;
  children: React.JSX.Element;
};

export const CalendarTimeSlot = ({
  value,
  children,
}: CalendarTimeSlotProps) => {
  return React.cloneElement(
    children,
    {
      'data-test': 'TIME_SLOT',
    },
    isValidElement(children.props?.children) ? (
      <Gutter horizontal="8px">
        <CondensedSmall name="TIME">
          {moment(value).format('ha')}
        </CondensedSmall>
      </Gutter>
    ) : null
  );
};
